//--- ARQUIVO NOVO: ConversionModal.js (Copie e cole tudo) ---
import React, { useState } from 'react';

export const ConversionModal = ({ budget, onConfirm, onCancel }) => {
    // Sugere uma data de vencimento 30 dias no futuro, mas permite alteração
    const suggestedDueDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    const [dueDate, setDueDate] = useState(suggestedDueDate);

    const handleConfirm = () => {
        if (dueDate) {
            onConfirm(dueDate);
        }
    };

    const formatCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md">
                <div className="p-6">
                    <h3 className="text-xl font-bold dark:text-gray-200 mb-2">Converter Orçamento</h3>
                    <p className="dark:text-gray-300 mb-4">
                        Você está convertendo o orçamento para <span className="font-semibold">{budget.clientName}</span> no valor de <span className="font-semibold">{formatCurrency(budget.total)}</span>.
                    </p>
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="dueDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                Qual a data de vencimento do Lançamento?
                            </label>
                            <input
                                type="date"
                                id="dueDate"
                                value={dueDate}
                                onChange={(e) => setDueDate(e.target.value)}
                                className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            />
                        </div>
                    </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/50 px-6 py-4 flex justify-end space-x-4 rounded-b-lg">
                    <button onClick={onCancel} className="px-4 py-2 bg-gray-200 dark:bg-gray-600 dark:text-gray-200 rounded-md">Cancelar</button>
                    <button onClick={handleConfirm} className="px-4 py-2 bg-blue-600 text-white rounded-md">Confirmar e Criar Lançamento</button>
                </div>
            </div>
        </div>
    );
};